import { put } from 'aws-amplify/api';
import { NEW_REST_API, NEW_REST_API__V2__UPLOAD_CSV } from '../../consts';
import { pubsub } from '../../utils/pubsub';
import { ensureAccountIotPolicy } from '../../utils/accountIotPolicy';

/** HTTP is authoritative; MQTT provides optional intermediate progress. */
export async function processCsvUpload(
  accountId: string,
  fileName: string,
  originalName: string,
  onProgress?: (percent: number) => void
) {
  if (!/^[A-Za-z0-9_-]+$/.test(accountId) || !/^[A-Za-z0-9_.-]+$/.test(fileName)) {
    throw new Error('Invalid CSV upload scope');
  }
  let subscription: { unsubscribe(): void } | undefined;
  try {
    try {
      // Attachment failures disable optional progress, not the independent import.
      await ensureAccountIotPolicy();
      subscription = pubsub.subscribe({
        topics: [`accounts/${accountId}/csv-uploads/${fileName}/progress`],
      }).subscribe({
        next: (data: any) => {
          const msg = data?.value ?? data;
          if (msg?.fileName !== fileName || !['string', 'number'].includes(typeof msg.progress) || msg.progress === '') return;
          const progress = Number(msg.progress);
          if (!Number.isFinite(progress) || progress < 0 || progress > 1) return;
          onProgress?.(Math.min(99, 50 + progress * 50));
        },
        error: () => console.warn('CSV progress subscription unavailable; awaiting upload response'),
      });
    } catch {
      console.warn('CSV progress subscription unavailable; awaiting upload response');
    }
    const response = await put({
      apiName: NEW_REST_API,
      path: NEW_REST_API__V2__UPLOAD_CSV(accountId),
      options: {
        body: { originalName, key: `public/${fileName}` },
        retryStrategy: { strategy: 'no-retry' },
      },
    }).response;
    onProgress?.(100);
    return response;
  } finally {
    subscription?.unsubscribe();
  }
}
